<template>
    <div class="homepage-video-player-container">
        <LiteYouTubeEmbed
            :id="videoId"
            class="video-modal-player-container"
            title="MommyDeals Video"
            params="autoplay=1&rel=0&modestbranding=1&playsinline=1"
            :preload="true"
            :no-cookie="false"
        />
        <div class="homepage-video-buttons">
            <div class="home-full-width-video-cta">
                <a :href="settings.socialLinks.whatsapp" target="_blank" @click="joinWhatsapp">
                    <button class="button-cta"><span class="play-icon"><img :src="`/assets/img/logo-whatsapp.png`" /></span>Deal Alerts</button>
                </a>
                <button class="button button-get-started" @click="stopVideo">Close</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import settings from '@/settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import EventBus from '@/helpers/event-bus'
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import 'vue-lite-youtube-embed/style.css'

const videoId = ref('gSM0FGKIDSY')

onMounted(() => {
    // Ensure the video container is visible
    const container = document.querySelector('.homepage-video-player-container')
    if (container) {
        (container as HTMLElement).style.display = 'block'
    }
})

const stopVideo = () => {
    EventBus.emit('stopHomepageVideo')
}
const joinWhatsapp = () => {
    ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' })
    clicky.goal("JoinWhatsAppHomepageVideo2")
}
</script>

